module.exports = __webpack_public_path__ + "static/media/tutorial-conlicitaseg-garantia-de-execucao.1af9fdfd.png";